import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const stack = ['react', 'flutter', 'typescript', 'node.js', 'react', 'flutter', 'typescript', 'node.js', 'react', 'flutter', 'typescript', 'node.js', 'react', 'flutter', 'typescript', 'node.js',];


const banner = {
  animate: {
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.1,
    },
  },
};

const letterAni = {
  initial: { y: 400 },
  animate: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1,
    },
  },
};

const Banner = () => {
  const [intro, setIntro] = useState('Hey')
  const [subIntro, setSubIntro] = useState('there!')
  const [playMarquee, setPlayMarquee] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setPlayMarquee(true);
    }, 3000);

    setTimeout(() => {
      setIntro("Name's");
      setSubIntro("Francis")
    }, 3100);
  }, []);
  return (
    <motion.div className='banner' variants={banner}>
      <BannerRowTop title={intro} />
      <BannerRowBottom title={subIntro} />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <BannerRowCenter title={"react"} playMarquee={playMarquee} />
    </motion.div>
  );
};

const AnimatedLetters = ({ title, disabled }) => (

  <motion.span
    className='row-title'
    variants={disabled ? null : banner}
    initial='initial'
    animate='animate'>
    {[...title].map((letter) => (
      <motion.span
        className='row-letter'
        variants={disabled ? null : letterAni}>
        {letter}
      </motion.span>
    ))}
  </motion.span>
);





const BannerRowTop = ({ title }) => {
  return (
    <div className={"banner-row"}>
      <div className='row-col'>
        <AnimatedLetters title={title} />
      </div>
      <motion.div
        initial={{ opacity: 0, y: 80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          ease: "easeInOut",
          duration: 1,
          delay: 0.4,
        }}
        className='row-col'>
        <span className='row-message'>
          I'm a software developer. I develop websites, mobile applications, games, and I have a crush on react and flutter.
        </span>
      </motion.div>
    </div>
  );
};

const BannerRowBottom = ({ title }) => {
  return (
    <div className={"banner-row center"}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ ease: [0.6, 0.01, -0.05, 0.95], duration: 1, delay: 1 }}
        className='scroll'>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            ease: "easeInOut",
            duration: 1,
            delay: 1.8,
          }}>
          scroll
        </motion.span>
        <motion.span
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            ease: "easeInOut",
            duration: 1,
            delay: 1.8,
          }}>
          down
        </motion.span>
      </motion.div>
      <AnimatedLetters title={title} />
    </div>
  );
};

const BannerRowCenter = ({ title, playMarquee }) => {
  return (
    <div className={`banner-row marquee  ${playMarquee && "animate"}`}>
      <motion.div
        initial={{ y: 310 }}
        animate={{ y: 0 }}
        transition={{ ease: [0.6, 0.01, -0.05, 0.9], duration: 1 }}
        className='marquee__inner'>
        <AnimatedLetters title={stack[0]} disabled />
        <AnimatedLetters title={stack[1]} />
        <AnimatedLetters title={stack[2]} disabled />
        <AnimatedLetters title={stack[3]} disabled />
        <AnimatedLetters title={stack[4]} disabled />
        <AnimatedLetters title={stack[5]} disabled />
        <AnimatedLetters title={stack[6]} disabled />
        <AnimatedLetters title={stack[7]} disabled />
        <AnimatedLetters title={stack[8]} disabled />
        <AnimatedLetters title={stack[9]} disabled />
        <AnimatedLetters title={stack[10]} disabled />
        <AnimatedLetters title={stack[11]} disabled />
        <AnimatedLetters title={stack[12]} disabled />
        <AnimatedLetters title={stack[13]} disabled />
        <AnimatedLetters title={stack[14]} disabled />

      </motion.div>
    </div>
  );
};

export default Banner;
